var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "print-list_box", attrs: { id: "nPrintingPageTable" } },
    [
      _c(
        "div",
        { staticClass: "yto-box yto-box-pb" },
        [
          _c(
            "el-form",
            { ref: "ruleForm", attrs: { inline: true, model: _vm.form } },
            [
              _c(
                "div",
                { staticClass: "y-f y-f-a" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "分享平台",
                        prop: "platformCode",
                        "label-width": "60px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "y-w-200",
                          attrs: {
                            "popper-append-to-body": false,
                            clearable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form.platformCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "platformCode", $$v)
                            },
                            expression: "form.platformCode",
                          },
                        },
                        _vm._l(_vm.platformCodeList, function (item) {
                          return _c("el-option", {
                            key: item.platformCode,
                            attrs: {
                              label: item.platformName,
                              value: item.platformCode,
                              disabled: item.disabled,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { float: "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getSettingInfo(1)
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "border-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-refresh-left y-fc-4C84FF",
                          }),
                          _vm._v("重置 "),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "yto-table yto-ks-box ksNewOrderTable",
          staticStyle: { padding: "8px 10px" },
        },
        [
          _c(
            "div",
            { staticClass: "y-mb-8" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openAuthRealNameDialogFn },
                },
                [_vm._v("新增二维码与链接")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "infinite-list-wrapper newCustomPrintTable",
              staticStyle: { overflow: "auto" },
            },
            [
              _vm.tableHeight
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "customOrderTable",
                      attrs: { data: _vm.tbody, height: _vm.tableHeight },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "qrUrl",
                          label: "二维码",
                          "min-width": 80,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("vue-qr", {
                                    ref: "imgRef" + scope.row.id,
                                    staticClass: "custom-qr",
                                    attrs: {
                                      "data-qr-id": scope.row.id,
                                      "logo-src": _vm.logoSrc,
                                      text: scope.row.qrUrl,
                                      size: 64,
                                      margin: 0,
                                      logoMargin: 4,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text", size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyQRImage(
                                                scope.row.qrUrl
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("复制")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text", size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadQRCode(
                                                scope.row.qrUrl
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下载")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2357132093
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "qrUrl",
                          label: "链接",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [_vm._v("-")]),
                                  false
                                    ? _c(
                                        "div",
                                        { staticClass: "y-t-ac" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyUtrl(
                                                    scope.row.qrUrl
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("复制链接")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3535079074
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupOrderNo",
                          label: "分享平台",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("微信" || scope.row.pickupOrderNo)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1279541669
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupOrderNo",
                          label: "退货收件地址",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.newAddressInfo
                                          ? scope.row.newAddressInfo
                                              .provinceName
                                          : ""
                                      ) +
                                        " " +
                                        _vm._s(
                                          scope.row.newAddressInfo
                                            ? scope.row.newAddressInfo.cityName
                                            : ""
                                        ) +
                                        " " +
                                        _vm._s(
                                          scope.row.newAddressInfo
                                            ? scope.row.newAddressInfo
                                                .districtName
                                            : ""
                                        ) +
                                        " " +
                                        _vm._s(
                                          scope.row.newAddressInfo
                                            ? scope.row.newAddressInfo.address
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.newAddressInfo
                                          ? scope.row.newAddressInfo.name
                                          : ""
                                      ) +
                                        " " +
                                        _vm._s(
                                          scope.row.newAddressInfo
                                            ? scope.row.newAddressInfo.mobile
                                              ? scope.row.newAddressInfo.mobile
                                              : scope.row.newAddressInfo.phone
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          353975392
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupOrderNo",
                          label: "寄件付费设置",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.brokerage
                                    ? _c("div", [
                                        _vm._v(
                                          "加价返佣 ：每单加" +
                                            _vm._s(scope.row.brokerage) +
                                            " 元"
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.buyerPaysShipping
                                    ? _c("div", [
                                        _vm._v("寄件人付运费 ： 全额运费"),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4039955221
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupOrderNo",
                          label: "其他设置",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.autoAudit
                                    ? _c("div", [
                                        _vm._v(
                                          "自动通过审核：" +
                                            _vm._s(
                                              scope.row.autoAudit == 1
                                                ? "开"
                                                : "关"
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.pickUpDateRule
                                    ? _c("div", [
                                        _vm._v(
                                          "取件日期 ：" +
                                            _vm._s(
                                              scope.row.pickUpDateRule == "2"
                                                ? "定时取"
                                                : scope.row.pickUpDateRule ==
                                                  "0"
                                                ? "当日取"
                                                : "未设置"
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.originalOrder
                                    ? _c("div", [
                                        _vm._v(
                                          "是否必填原单号：" +
                                            _vm._s(
                                              scope.row.originalOrder == "1"
                                                ? "是"
                                                : scope.row.originalOrder == "0"
                                                ? "否"
                                                : ""
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1464362029
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "200", fixed: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "systemColor y-c-p",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modifyFn(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  ),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red-txt y-c-p",
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancelFn(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("作废")]
                                  ),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3765224328
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.showInviteSettingDialog
        ? _c("inviteSetting", {
            ref: "inviteSetting",
            attrs: {
              isShow: _vm.showInviteSettingDialog,
              rowInfo: _vm.rowInfo,
              isEdit: _vm.isEdit,
            },
            on: {
              closeDialog: _vm.closeInviteSettingDialog,
              refreshTable: _vm.refreshTable,
              openSaveAccount: _vm.openSaveAccount,
              openPreAilDialog: _vm.openPreAilDialog,
              goToRealName: _vm.goToRealName,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }